'use client'

import { getWagmiAdapter } from '@repo/web3'

import { getClientEnvVar, isE2E } from '@/lib/config/app.config'
import { SUPPORTED_CHAINS } from '@/lib/modules/web3/web3.config'

export const { wagmiConfig, wagmiAdapter } = getWagmiAdapter({
  chainIds: SUPPORTED_CHAINS,
  projectId: getClientEnvVar('NEXT_PUBLIC_REOWN_APP_ID') ?? '',
  batch: {
    multicall: { batchSize: 64_000 } // TODO: This works, but Alchemy recommends <= 100kb. Test at some point
  },
  options: {
    isE2E,
    getEnvVar: getClientEnvVar
  }
})
